import React from 'react';
import { pure } from 'recompose';
import './VideoNavBar.css';

const VideoNavBar = ({ index, count, onClick }) => (
  <div className="VideoNavBar">
    <button
      className={index <= 1 ? 'disabled' : undefined}
      onClick={() => onClick && onClick('first')}
    >
      <span className="fontawesome-fast-backward" />
    </button>
    <button
      className={index <= 1 ? 'disabled' : undefined}
      onClick={() => onClick && onClick('prev')}
    >
      <span className="fontawesome-backward" />
    </button>
    <span className="caption">{`${index}/${count}`}</span>
    <button
      className={index === count ? 'disabled' : undefined}
      onClick={() => onClick && onClick('next')}
    >
      <span className="fontawesome-forward" />
    </button>
    <button
      className={index === count ? 'disabled' : undefined}
      onClick={() => onClick && onClick('last')}
    >
      <span className="fontawesome-fast-forward" />
    </button>
  </div>
);

export default pure(VideoNavBar);



// WEBPACK FOOTER //
// ./src/components/tools/VideoTool/VideoNavBar.jsx